import { render, staticRenderFns } from "./ConfigPersonIdIdentifierSummary.vue?vue&type=template&id=4d31a2c0&scoped=true&"
import script from "./ConfigPersonIdIdentifierSummary.vue?vue&type=script&lang=js&"
export * from "./ConfigPersonIdIdentifierSummary.vue?vue&type=script&lang=js&"
import style0 from "./ConfigPersonIdIdentifierSummary.vue?vue&type=style&index=0&id=4d31a2c0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d31a2c0",
  null
  
)

export default component.exports